/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { OrderIncompleteDeliveryReason } from './OrderIncompleteDeliveryReason';
// @ts-ignore
import {
// @ts-ignore
    OrderIncompleteDeliveryReasonFromJSON,
// @ts-ignore
    OrderIncompleteDeliveryReasonFromJSONTyped,
// @ts-ignore
    OrderIncompleteDeliveryReasonToJSON,
} from './OrderIncompleteDeliveryReason';

/**
 * 
 * @export
 * @interface OrderIncompleteDeliveryCreateRequest
 */
export interface OrderIncompleteDeliveryCreateRequest {
    /**
     * 
     * @type {OrderIncompleteDeliveryReason}
     * @memberof OrderIncompleteDeliveryCreateRequest
     */
    reason: OrderIncompleteDeliveryReason;
    /**
     * 
     * @type {string}
     * @memberof OrderIncompleteDeliveryCreateRequest
     */
    comment?: string;
}

/**
 * Check if a given object implements the OrderIncompleteDeliveryCreateRequest interface.
 */
// @ts-ignore
export function instanceOfOrderIncompleteDeliveryCreateRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "reason" in value;

    return isInstance;
}

// @ts-ignore
export function OrderIncompleteDeliveryCreateRequestFromJSON(json: any): OrderIncompleteDeliveryCreateRequest {
    return OrderIncompleteDeliveryCreateRequestFromJSONTyped(json, false);
}

// @ts-ignore
export function OrderIncompleteDeliveryCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderIncompleteDeliveryCreateRequest {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'reason': OrderIncompleteDeliveryReasonFromJSON(json['reason']),
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
    };
}

// @ts-ignore
export function OrderIncompleteDeliveryCreateRequestToJSON(value?: OrderIncompleteDeliveryCreateRequest | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'reason': OrderIncompleteDeliveryReasonToJSON(value.reason),
        'comment': value.comment,
    };
}

